import { render, staticRenderFns } from "./pageLockedNote.vue?vue&type=template&id=1d90266c&scoped=true"
import script from "./pageLockedNote.vue?vue&type=script&lang=js"
export * from "./pageLockedNote.vue?vue&type=script&lang=js"
import style0 from "./pageLockedNote.vue?vue&type=style&index=0&id=1d90266c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90266c",
  null
  
)

export default component.exports